/**
 * @file get-fr.js
 * @author rongtan<rongtan@baidu.com>
 * @date 2020-12-23
 */
/**
 * 获取 url 中拼的来源值, 兼容由于历史原因来源值用 sourceFrom 字段表示的情况
 *
 * @return {string} url 中拼的来源值
 * @example
 * getFr()
 */
import url from '@utils/url';

const PAGE_PARAMS = url.parse(location.href).params;

export default () => PAGE_PARAMS.fr || PAGE_PARAMS.sourceFrom || '';
